module.exports = __webpack_public_path__ + "img/iconChaNew.d365c2fb.png";